export default defineNuxtRouteMiddleware((to) => {
  const appStore = useAppStore()

  const hasDevModeQuery = to.query.devMode === 'true'

  if (!appStore.devMode && hasDevModeQuery) {
    appStore.$patch({ devMode: true })
  }
})
